import { html } from "lit";
import { getDummyText, getDummyHtml } from "../../../utils";

export function Template(args) {
    const textColor =
        args.background === "blue" || args.background === "green"
            ? "ux-color-white-children"
            : "";
    const backgroundColor = "ux-u-background-" + args.background;
    return html`
        <ux-iws-link-wrapper class="ux-u-text-align--center">
            <div class="ux-row ${backgroundColor} ux-u-pt-m ux-u-pb-m">
                <div class="ux-col-10 ux-u-offset-1">
                    ${args.withHeadline
                        ? html`
                              <div class="${textColor}">
                                  ${args.headline === "h1"
                                      ? html`
                                            <h1
                                                class="ux-text-headline ux-text-headline--giant"
                                            >
                                                ${getDummyText(30)}
                                            </h1>
                                        `
                                      : html`
                                            <h2
                                                class="ux-text-headline ux-text-headline--big"
                                            >
                                                ${getDummyText(30)}
                                            </h2>
                                        `}

                                  <div class="ux-u-mb-xxs"></div>
                              </div>
                          `
                        : html``}
                    ${args.withTags
                        ? html`
                              <div>
                                  <span class="ux-tag">Tag 1</span>
                                  <span class="ux-tag">Tag 2</span>
                                  <span class="ux-tag">Tag 3</span>
                              </div>
                          `
                        : html``}
                    ${args.withBodyText
                        ? html`
                              <div class="ux-text-normal ${textColor}">
                                  ${getDummyHtml()}
                              </div>
                          `
                        : html``}
                    ${args.withButton
                        ? html`
                              <div class="ux-u-mt-xs ux-u-mb-xxxs">
                                  <a
                                      href="#"
                                      class="ux-button ${args.background !==
                                      "green"
                                          ? "ux-button--green"
                                          : ""}"
                                  >
                                      Discover more
                                  </a>
                              </div>
                          `
                        : html``}
                </div>
            </div>
        </ux-iws-link-wrapper>
    `;
}
